import { BaseQueryFn, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { HTTP_METHODS } from './constants'

export function getBaseQuery (): BaseQueryFn {
  return fetchBaseQuery({
    baseUrl: process.env.NEXT_PUBLIC_ADMIN_URL,
    prepareHeaders: (headers, {}) => {
      headers.set('Content-Type', 'application/json')
      return headers
    },
    responseHandler: async (response) => {
      const text = await response.text()
      try {
        return JSON.parse(text)
      } catch {
        return text
      }
    }
  })
}

export function generateRPCQuery (
  url: string,
  method: string,
  params?: any
): RPCQuery {
  return {
    url,
    credentials: 'include',
    method: HTTP_METHODS.POST,
    headers: { 'Content-Type': 'application/json' },
    body: {
      jsonrpc: '2.0',
      method,
      params,
      id: 1
    }
  }
}

export interface RESTQueryConfig {
  path: string
  method?: (typeof HTTP_METHODS)[keyof typeof HTTP_METHODS]
  body?: unknown
  queryParams?: Record<string, unknown> | object
}

export function generateRESTQuery ({
  path,
  method = HTTP_METHODS.GET,
  body,
  queryParams
}: RESTQueryConfig) {
  let url = path

  if (queryParams) {
    const searchParams = new URLSearchParams()

    Object.entries(queryParams).forEach(([key, value]) => {
      if (value == null) {
        return
      }

      if (Array.isArray(value)) {
        value.forEach((item) => {
          if (item == null) {
            return
          }
          searchParams.append(key, String(item))
        })
        return
      }

      searchParams.append(key, String(value))
    })

    const queryString = searchParams.toString()
    if (queryString) {
      url = `${path}?${queryString}`
    }
  }

  return {
    url,
    credentials: 'include' as const,
    method,
    headers: { 'Content-Type': 'application/json' },
    ...(body !== undefined ? { body } : {})
  }
}
